class FetchError extends Error {
	constructor(message, code) {
		super(message);
		this.name = "FetchError";
		this.code = code;
	}
}

export default FetchError;
